module.exports = __webpack_public_path__ + "img/vsBronzer5.afc28763.jpg";